// components/PeriodicExpensesCard/PeriodicExpensesCard.jsx
import React, {useEffect, useState} from 'react';
import {Alert, Card, Statistic, Tooltip} from 'antd';
import {CalendarOutlined, InfoCircleOutlined} from '@ant-design/icons';
import style from './styles/PeriodicExpensesCard.module.css';
import {instance} from "../../../../../API/API";
import ExpensesType from "./ExpensesType";
import MiddleStatistic from "./MiddleStatistic";
import ActivePayments from "./ActivePayments";
import PaymentsByCategory from "./PaymentsByCategory";
import dayjs from "dayjs";

const PeriodicExpensesCard = ({dateRange, selectedCategory, refreshKey}) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [data, setData] = useState({
        total: 0,
        cash: 0,
        non_cash: 0,
        avg_monthly: 0,
        summary: {},
        by_category: []
    });

    const fetchData = async () => {
        setLoading(true);
        setError(null);

        try {
            const params = {
                date_from: dateRange[0].format('YYYY-MM-DD'),
                date_to: dayjs(dateRange[1].format('YYYY-MM-DD'),'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD'),
            };

            if (selectedCategory) {
                params.category_id = selectedCategory;
            }

            const response = await instance.get(`finance_04122025/get_periodic_expenses_stats.php`, {
                params,
                withCredentials: true,
            });

            if (response.data.success) {
                setData(response.data.data);
            } else {
                throw new Error(response.data.error || 'Failed to load periodic expenses data');
            }
        } catch (err) {
            console.error('Error fetching periodic expenses:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [dateRange, selectedCategory, refreshKey]);

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };

    if (error) {
        return (
            <Card className={style.card}>
                <Alert
                    message="Ошибка"
                    description="Не удалось загрузить данные по периодическим расходам"
                    type="error"
                    showIcon
                />
            </Card>
        );
    }

    return (
        <Card
            className={`${style.card} ${style.periodicCard}`}
            hoverable
            loading={loading}
        >
            <div className={style.cardHeader}>
                <div className={style.title}>
                    <CalendarOutlined className={style.icon}/>
                    <span>Периодические</span>
                </div>
                <Tooltip title="Регулярные платежи по расписанию">
                    <InfoCircleOutlined className={style.infoIcon}/>
                </Tooltip>
            </div>


            <Statistic
                value={data.total}
                precision={2}
                suffix="€"
                valueStyle={{
                    color: '#1890ff',
                    fontSize: '24px',
                    fontWeight: 600
                }}
                className={style.statistic}
            />

            <ExpensesType cash={formatCurrency(data.cash)} non_cash={formatCurrency(data.non_cash)}/>
            <MiddleStatistic summ={formatCurrency(data.avg_monthly)} period={data.period_months}/>
            <ActivePayments count={data.summary.active_payments_count || 0}/>

            {data.by_category.length > 0 && (
                <div className={style.cardFooter}>
                    <PaymentsByCategory setIsModalVisible={setIsModalVisible}
                                        data={data}
                                        isModalVisible={isModalVisible}
                                        formatCurrency={formatCurrency}
                    />
                </div>
            )}
        </Card>
    );
};

export default PeriodicExpensesCard;